var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"grid grid-cols-1 gap-x-1.5 md:gap-x-5 md:gap-y-30px",class:{
    'md:grid-cols-3': _vm.cols === 3,
    'md:grid-cols-4': _vm.cols === 4,
  }},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"border-b py-5 first:pt-0 last:border-0 md:border-0 md:py-0"},[_c('AppArticleCard',{attrs:{"item":item,"authors":_vm.authors,"categories":_vm.categories,"ga-parts-type":_vm.gaPartsType,"is-fav-button-hidden":_vm.isFavButtonHidden}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }